export enum FollowUpStudyFieldErrorCode {
	Required = "REQUIRED",
	MaxLength = "MAX_LENGTH",
	FutureDate = "FUTURE_DATE",
	InvalidValue = "INVALID_VALUE",
	DuplicateValue = "DUPLICATE_VALUE",
	InvalidCombination = "INVALID_COMBINATION",
	ReportNotApproved = "REPORT_NOT_APPROVED",
	MinItems = "MIN_ITEMS",
	MaxItems = "MAX_ITEMS",
}
